import {
  BreadcrumbItems,
  MetaDataType,
  PartitionDataType,
  SelectedArtefactType
} from "@emisgroup/cohort-builder-kit";

export enum ArtefactTypes {
  PARTITION = 1,
  SEARCH,
  REPORT,
  CODELIST
}

export interface IPartitionMeta {
  key: string;
  value: string;
  createdOn: string;
  createdBy: string;
  modifiedBy: string;
  modifiedOn: string;
}

export interface IPartitionInput {
  /**
* Artifact Id
*/
  artefactId: string;
}

export interface IInitialState {
  artefacts: SelectedArtefactType[];
  selectedId?: string;
  breadcrumbItems?: BreadcrumbItems[];
  parentData: PartitionDataType;
  metaData: MetaDataType[];
}

export type Environments = "sbx" | "dev" | "int" | "stg" | "prd";
